if ( document.querySelector( '.checklist-gallery' ) ) {
    jQuery( '.checklist-gallery' ).slick( {
        centerMode: true,
        centerPadding: '16%',
        slidesToShow: 3,
        slidesToScroll: 1,
        fade: false,
        autoplay: true,
        autoplaySpeed: 3000,
        rows: 0,
        infinite: true,
        pauseOnHover: false,
        arrows: true,
        prevArrow: jQuery( '.checklist-gallery-prev' ),
        nextArrow: jQuery( '.checklist-gallery-next' ),
        responsive: [
            {
                breakpoint: 1300,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 1023,
                settings: {
                    centerPadding: '10%',
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 540,
                settings: {
                    centerPadding: '5%',
                    slidesToShow: 1,
                }
            }
        ]
    } );
}